import styled from 'styled-components/macro'

export const Wrap = styled.div<{ extraStyles?: string }>`
  z-index: 5;
  /* Half-strength veil of the THEME's page surface (was a hardcoded light
     rgba(247,248,254,.5), which flashed a milky sheet over dark themes).
     Static fallback preserves the legacy veil where color-mix is missing. */
  background-color: rgba(247, 248, 254, 0.5);
  background-color: color-mix(in srgb, var(--surface-page) 50%, transparent);
  backdrop-filter: blur(10px);
  min-height: 100vh;
  min-width: 100vw;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  // overrides:
  ${({ extraStyles }) => extraStyles}
`
